<div class="map-container">
  @if (loading()) {
    <div class="mapa-cargando" role="status">
      <mat-progress-spinner
        mode="indeterminate"
        color="primary"
        [diameter]="20"
      ></mat-progress-spinner>
      <span>Cargando sirenas…</span>
    </div>
  }

  @if (sirenasG) {
    <div class="mapa-flotante">
      <app-flotante-sirenas
        [sirenas]="sirenasG"
        (sirenaChange)="onSirenaChange($event)"
        (clusterChange)="onClusterToggle($event)"
      ></app-flotante-sirenas>
    </div>
  }

  <app-mapa-facil-v2
    [zoom]="12"
    [mapId]="'mapa-sirenas'"
    [mapasPersonalizados]="mapasPersonalizados"
    [allowedEntityTypes]="allowedTypes"
    [includeGeometriesOnStyleChange]="false"
    (mapReady)="onMapReady($event)"
  ></app-mapa-facil-v2>
</div>
